import { gql } from "@apollo/client";

const Fragments = {
  partnerForCompanyData: gql`
    fragment partnerForCompanyData on PartnerForCompanyData {
      partnerId
      name
      city
      state
      address
      zip
      phone
      taxId
      origin
      bureauId
    }
  `,
};

export default Fragments;
